import React from 'react';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {Trans} from "react-i18next";

export default ({open, handleCancel, handleOk, ...other}) => {
  return <Dialog
    disableBackdropClick
    disableEscapeKeyDown
    maxWidth="xs"
    aria-labelledby="confirmation-dialog-title"
    open={open}
    {...other}
  >
    <DialogTitle id="confirmation-dialog-title">
      <Trans>Delete product?</Trans>
    </DialogTitle>
    <DialogContent dividers>
      <Trans>Are you sure you want to delete the product from the shopping cart?</Trans>
    </DialogContent>
    <DialogActions>
      <Button autoFocus onClick={handleCancel} color="primary">
        <Trans>Cancel</Trans>
      </Button>
      <Button onClick={handleOk} color="primary">
        <Trans>Delete</Trans>
      </Button>
    </DialogActions>
  </Dialog>
}